import { render, staticRenderFns } from "./ProfileCardPopup.vue?vue&type=template&id=ce609cbc&scoped=true&"
import script from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
export * from "./ProfileCardPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCardPopup.vue?vue&type=style&index=0&id=ce609cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce609cbc",
  null
  
)

export default component.exports